import { render, staticRenderFns } from "./ChatAttendanceDialog.vue?vue&type=template&id=2cdccae2&scoped=true"
import script from "./ChatAttendanceDialog.vue?vue&type=script&lang=js"
export * from "./ChatAttendanceDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatAttendanceDialog.vue?vue&type=style&index=0&id=2cdccae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdccae2",
  null
  
)

export default component.exports